// extracted by mini-css-extract-plugin
export default {"evidenceImg":"styles_evidenceImg__au7Rt"};